import {DatePipe} from '@angular/common';
import {Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Pipe({
  name: 'dateToString',
})
export class DateToStringPipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  transform(value: string, location: 'chatroom' | 'message') {
    const inputDate = new Date(Date.parse(value));
    const datePipe = new DatePipe('en-US');
    const today = new Date();

    const isToday =
      today.getFullYear() === inputDate.getFullYear() &&
      today.getMonth() === inputDate.getMonth() &&
      today.getDay() === inputDate.getDay();

    const isYesterday =
      today.getFullYear() === inputDate.getFullYear() &&
      today.getMonth() === inputDate.getMonth() &&
      (inputDate.getDay() === today.getDay() - 1 ||
        (inputDate.getDay() === 6 && today.getDay() === 0));

    switch (location) {
      case 'message':
        if (isToday) {
          return datePipe.transform(inputDate, 'H:mm');
        }
        return datePipe.transform(inputDate, 'd MMM');
      case 'chatroom':
        if (isToday) {
          return datePipe.transform(inputDate, 'H:mm');
        }
        if (isYesterday) {
          return this.translate.instant('YESTERDAY');
        }
        return datePipe.transform(inputDate, 'd MMM');
      default:
        return;
    }
  }
}
